import { Component, OnDestroy, OnInit } from '@angular/core';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { Router } from '@angular/router';
import { AngularFireStorage } from '@angular/fire/storage';
import { SmtpConfigurationService } from 'src/app/service/smtp-configuration/smtp-configuration.service';
import { AuthService } from 'src/app/service/auth/auth.service';
import { Subscription } from 'rxjs';
import { ToolsService } from 'src/app/service/tools/tools.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  loginUserData;
  fullName;
  egan_hub_site_logo = '../../../assets/images/logo/ae_logo.png';
  totalCountLabel;
  totalCount;
  countShouldBeVisible;

  subscription: Subscription;

  constructor(
    private localStorageService: LocalstorageService,
    private router: Router,
    private storage: AngularFireStorage,
    private smtpConfigurationService: SmtpConfigurationService,
    private authService: AuthService,
    private toolsService: ToolsService,
  ) {}

  ngOnInit(): void {
    this.loginUserData = JSON.parse(this.localStorageService.getItem('user'));
    if (this.loginUserData) {
      this.fullName = this.loginUserData['firstName'] + ' ' + this.loginUserData['lastName'];
    }
    this.subscription = this.toolsService.currentTotalCount.subscribe(totalCount => (this.totalCount = totalCount));
    this.subscription = this.toolsService.currentTotalCountLabel.subscribe(
      totalCountLabel => (this.totalCountLabel = totalCountLabel),
    );
    this.subscription = this.toolsService.countShouldBeVisible.subscribe(
      countShouldBeVisible => (this.countShouldBeVisible = countShouldBeVisible),
    );
    this.getSmtpConfiguration();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  logout() {
    this.localStorageService.removeItem('userId');
    this.localStorageService.removeItem('user');
    this.localStorageService.removeItem('token');
    this.authService.logout().subscribe(res => {
      this.router.navigateByUrl('/');
    });
  }

  getSmtpConfiguration() {
    this.smtpConfigurationService.getSiteConfiguration().subscribe(
      res => this.onSmtpSuccess(res),
      error => this.onSmtpError(error),
    );
  }

  onSmtpSuccess(result) {
    if (result) {
      if (result.data) {
        result.data.forEach(element => {
          if (element.config_item == 'egan_hub_site_logo') {
            if (element.config_value != '') {
              let siteLogo = this.storage.ref('uploads/site_logo/' + element.config_value);
              siteLogo.getDownloadURL().subscribe(url => {
                if (url) {
                  this.egan_hub_site_logo = url;
                }
              });
            }
          }
        });
      }
    }
  }

  onSmtpError(error) {}
}
